import { formatDimensionValue } from "@/lib/formatDimensionValue";
import { api } from "@/services/api";

/** Subtitle under the Twido logo on the home dashboard for Client users. */
export const CLIENT_PORTAL_WORKSPACE_SUBTITLE = "Client portal";

export function formatConsigneeNavLabel(
  canonicalCode: string,
  entityLabel: string | null | undefined,
): string {
  const trimmed = canonicalCode.trim();
  if (!trimmed) return "";
  return formatDimensionValue("consignee", entityLabel?.trim() || trimmed);
}

/** Resolve supply-chain display name for a canonical consignee code. */
export async function resolveConsigneeEntityLabel(
  canonicalCode: string,
): Promise<string | null> {
  const code = canonicalCode.trim();
  if (!code) return null;
  const rows = await api.getBookingFilterValues("consignee", code, 30);
  const hit = rows.find(
    (r) => r.value.toLowerCase() === code.toLowerCase(),
  );
  return hit?.label?.trim() || null;
}
